import { FIRESTORE_FUNCTIONS } from "../../constants/firebase.constants";
import { getFunctions, httpsCallable } from "firebase/functions";

export const firebaseHttpsCallable = <Req, Res>(
  functionName: FIRESTORE_FUNCTIONS
) => httpsCallable<Req, Res>(getFunctions(), functionName);
